module.exports = __webpack_public_path__ + "img/file.b8eb9923.svg";